import config from "@/config"
import http from "@/utils/request"

export default {
    priceDiscount: {
        getPageList: {
            url: `${config.API_URL}/api/app/price-discount/page-list`,
            name: "获取价格折扣分页数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        create: {
            url: `${config.API_URL}/api/app/price-discount`,
            name: "创建价格折扣",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        update: {
            url: `${config.API_URL}/api/app/price-discount`,
            name: "修改价格折扣",
            put: async function (params) {
                return await http.put(this.url, params);
            }
        },
        cancel: {
            url: `${config.API_URL}/api/app/price-discount/cancel`,
            name: "取消",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        }
    },
    priceDiscountLog: {
        getPageList: {
            url: `${config.API_URL}/api/app/price-discount-log/page-list`,
            name: "获取价格折扣操作日志",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    },
    coupon: {
        getCampaignPageList: {
            url: `${config.API_URL}/api/app/amazon-coupon-campaign/page-list`,
            name: "获取优惠券活动数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getcDetail: {
            url: `${config.API_URL}/api/app/amazon-coupon-campaign/detail`,
            name: "获取优惠券活动详情",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        create: {
            url: `${config.API_URL}/api/app/amazon-coupon-campaign`,
            name: "创建优惠券活动",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        calcelCampaign: {
            url: `${config.API_URL}/api/app/amazon-coupon-campaign/cancel`,
            name: "取消优惠券活动",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        log: {
            url: `${config.API_URL}/api/app/amazon-coupon-log/page-list`,
            name: "获取优惠券日志",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getCouponPageList: {
            url: `${config.API_URL}/api/app/amazon-coupon/page-list`,
            name: "获取优惠券数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getCouponDetail: {
            url: `${config.API_URL}/api/app/amazon-coupon/detail`,
            name: "获取优惠券详情",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getAsinPageList: {
            url: `${config.API_URL}/api/app/amazon-coupon-asin/page-list`,
            name: "获取ASIN数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
    },
    bestDeal: {
        getBestDealProductPageList: {
            url: `${config.API_URL}/api/app/best-deal-product/page-list`,
            name: "获取BestDeal产品数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    }
}